<template>
	<label class="el-button text-reader"
		   v-bind="attrsStylesClass"
			:class="[{'is-loading': isFileLoading, 'disbaled': isFileLoading}, ...classAttrs]">
		<i v-if="isFileLoading || isLoading" class="fontello icon-spin5"></i><slot>Pick a file</slot>
<!--		<input ref="localInput" v-if="!isFileLoading && !isLoading" type="file" @change="onFilePicked" :accept="filter.join(',')">-->
		<LocalFilePicker
			v-if="!isFileLoading && !isLoading"
			ref="localInput"
			@fileSelected="fileSelected"
			@loadingChange="loadingChanged"
			:sizeLimit="sizeLimit"
			:filter="filter"
			:filterNames="filterNames"
			:loadFileOnSelect="loadFileOnSelect"

			/>
<!--		<input ref="localInput" v-if="!isFileLoading && !isLoading" type="file" @change="onFilePicked" :accept="filter.join(',')">-->
	</label>

</template>

<script>

	import BaseComponent from "@/core/components/BaseComponent.vue";
	import LocalFilePicker from "@/core/components/File/LocalFilePicker.vue";

	export default {
		components: {LocalFilePicker},
		extends: BaseComponent,
        name: "PickFileButton",
		props:{
			classAttrs:{Array, default: () => ["el-button--primary", "el-button--mini"]},
			sizeLimit:{type: Number, default: 2 * 1024 * 1024},
			isLoading:{type: Boolean, default: false},
			filter:{type: Array, default: () => []},
			filterNames:{type: Array, default: () => []},
			loadFileOnSelect:{type: Boolean, default: true},
		},
		inheritAttrs: false,

		data: () => ({
			isFileLoading: false,
			// fileManager: null
		}),

		// mounted(){
		// 	this.fileManager = this.$fileUploader.fileManager
		// },

		methods: {
			startFilePick(){
				this.$refs.localInput.pickFile()
			},

			loadingChanged(isLoading){
				this.isFileLoading = isLoading
			},

			fileSelected(qwoachFile, localFile){
				this.$emit("fileSelected", qwoachFile, localFile);
			},
			//
			// onFilePicked(ev) {
			// 	if(this.isFileLoading){
			// 		return;
			// 	}
			// 	if(!ev.target){
			// 		return
			// 	}
			// 	let fileInput = ev.target
			// 	let file = fileInput.files[0];
			// 	ev.target.value = null
			// 	if(!file){
			// 		return;
			// 	}
			// 	let qwoachFile = this.fileManager.fileToQwoachFile(file)
			// 	if(!this.fileNameIsAllowed(file.name)){
			// 		let filters = this.filterNames.length > 0 ? this.filterNames : this.filter
			// 		console.log("filters = ", filters)
			// 		this.toastWarn(`Only ${filters.join(", ")} files are allowed`)
			// 		return
			// 	}
			// 	if(file.size > this.sizeLimit){
			// 		this.toastWarn("File is too big (" + humanFileSize(this.sizeLimit) + " max)")
			// 		return
			// 	}
			// 	if(this.loadFileOnSelect){
			// 		this.isFileLoading = true
			// 		const reader = new FileReader();
			//
			// 		reader.onload = e => {
			// 			// fileInput.value = null
			// 			this.isFileLoading = false
			// 			this.$emit("fileSelected", qwoachFile, e.target.result);
			// 		}
			// 		reader.onerror = e => {
			// 			fileInput.value = null
			// 			this.isFileLoading = false
			// 			console.error(e)
			// 		}
			// 		reader.readAsDataURL(file);
			// 	} else {
			// 		this.$emit("fileSelected", qwoachFile);
			// 	}
			// },
			//
			// fileNameIsAllowed(fileName){
			// 	console.log("fileNameIsAllowed: ", fileName)
			// 	if(this.filter.length === 0){
			// 		return true
			// 	}
			// 	for(let filter of this.filter){
			// 		if(fileName.endsWith(filter)){
			// 			console.log("fileNameIsAllowed: ends with ", filter)
			// 			return true
			// 		}
			// 	}
			// 	return false
			// }

		}
    }
</script>

<style scoped>
	.text-reader {
		position: relative;
		overflow: hidden;
		display: inline-block;
	}
	.text-reader input {
		position: absolute;
		top: 0;
		left: 0;
		z-index: -1;
		opacity: 0;
	}
</style>
